{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://entities/rsa",
  "title": "RSA",
  "type": "object",
  "$defs": {
    "date": {
      "type": "string",
      "format": "date",
      "formatKey": "DATE_MDY"
    },
    "shares": {
      "type": "number",
      "displayFormat": "number",
      "displayPrecision": 4
    },
    "amount": {
      "type": "number",
      "displayFormat": "currency",
      "displayPrecision": 4
    }
  },
  "properties": {
    "grantNumber": {
      "type": "string",
      "title": "Grant / Award Number"
    },
    "participantName": {
      "type": "string",
      "title": "Participant Name"
    },
    "employeeId": {
      "type": "string",
      "title": "Employee ID"
    },
    "purchaseDate": {
      "$ref": "#/$defs/date",
      "title": "Purchase Date"
    },
    "shares": {
      "$ref": "#/$defs/shares",
      "title": "Shares Purchased"
    },
    "purchasePrice": {
      "$ref": "#/$defs/amount",
      "title": "Purchase Price ($)"
    },
    "fmv": {
      "$ref": "#/$defs/amount",
      "title": "FMV ($)"
    },
    "cost": {
      "$ref": "#/$defs/amount",
      "title": "Cost ($)"
    },
    "taxableIncome": {
      "$ref": "#/$defs/amount",
      "title": "Taxable Income ($)"
    },
    "election83bStatus": {
      "type": "string",
      "title": "83(b) Election"
    },
    "election83bFiledDate": {
      "$ref": "#/$defs/date",
      "title": "83(b) Filed Date"
    },
    "settlementType": {
      "type": "string",
      "title": "Settlement Type"
    },
    "fundingRequired": {
      "$ref": "#/$defs/amount",
      "title": "Funding Required ($)"
    },
    "fundedAmount": {
      "$ref": "#/$defs/amount",
      "title": "Funded Amount ($)"
    },
    "totalTaxes": {
      "$ref": "#/$defs/amount",
      "title": "Total Taxes ($)"
    },
    "repurchaseShares": {
      "$ref": "#/$defs/shares",
      "title": "Repurchase Shares"
    },
    "netShares": {
      "$ref": "#/$defs/shares",
      "title": "Net Shares"
    },
    "shareDestination": {
      "type": "string",
      "title": "Share Destination"
    },
    "transactionStatus": {
      "type": "string",
      "title": "Status"
    }
  }
}
